import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "qr-scanner-overlay"
}
const _hoisted_2 = { class: "scanner-container" }
const _hoisted_3 = { class: "video-container" }
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}

import { ref, onMounted, onUnmounted, watch } from 'vue';
import { BrowserQRCodeReader, IScannerControls } from '@zxing/browser';

interface Props {
  isOpen: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'QRScanner',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["scanned", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const videoElement = ref<HTMLVideoElement | null>(null);
const error = ref<string | null>(null);

let codeReader: BrowserQRCodeReader | null = null;
let scannerControls: IScannerControls | null = null;

/**
 * Startet den Scanner (ZXing managt Kamera + Stream)
 */
async function startScanning() {
  if (!videoElement.value) return;

  try {
    error.value = null;

    if (!codeReader) {
      codeReader = new BrowserQRCodeReader();
    }

    // Continuous Scan über decodeFromVideoDevice
    scannerControls = await codeReader.decodeFromVideoDevice(
      undefined, // undefined = automatisch geeignete Kamera wählen (i. d. R. Back-Cam)
      videoElement.value,
      (result, err, controls) => {
        // controls stehen auch hier zur Verfügung
        if (controls) {
          scannerControls = controls;
        }

        if (result) {
          const text = result.getText();
          console.log('QR-Code gefunden:', text);
          emit('scanned', text);
          close(); // stopScanning() wird hier aufgerufen
        }

        // Fehler ignorieren, die einfach "kein Code gefunden" bedeuten
        if (err && err.name !== 'NotFoundException') {
          console.error('Scanner-Fehler:', err);
        }
      }
    );
  } catch (err) {
    console.error('Kamera-Fehler:', err);
    error.value = 'Kamera-Zugriff verweigert oder nicht verfügbar';
  }
}

/**
 * Stoppt den Scanner
 */
function stopScanning() {
  if (scannerControls) {
    try {
      scannerControls.stop();
    } catch (e) {
      console.warn('Fehler beim Stoppen des Scanners (ignoriert):', e);
    }
    scannerControls = null;
  }

  // Reader-Instanz verwerfen
  codeReader = null;

  // Video-Element aufräumen
  if (videoElement.value) {
    videoElement.value.srcObject = null;
  }
}

/**
 * Schließt den Scanner
 */
function close() {
  stopScanning();
  emit('close');
}

// Watcher: Scanner starten/stoppen wenn isOpen sich ändert
watch(
  () => props.isOpen,
  (newValue) => {
    if (newValue) {
      setTimeout(startScanning, 100); // Kurze Verzögerung für DOM-Rendering
    } else {
      stopScanning();
    }
  }
);

onMounted(() => {
  if (props.isOpen) {
    startScanning();
  }
});

onUnmounted(() => {
  stopScanning();
});

return (_ctx: any,_cache: any) => {
  return (__props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", { class: "scanner-header" }, [
            _cache[0] || (_cache[0] = _createElementVNode("h2", null, "QR-Code scannen", -1)),
            _createElementVNode("button", {
              onClick: close,
              class: "close-button"
            }, "✕")
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("video", {
              ref_key: "videoElement",
              ref: videoElement,
              class: "scanner-video",
              autoplay: "",
              playsinline: ""
            }, null, 512),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "scanner-frame" }, null, -1))
          ]),
          (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "scanner-instructions" }, [
            _createElementVNode("p", null, "Halte den QR-Code der Spielkarte in den Rahmen")
          ], -1))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})